<template>
  <div id="application-sftp">
    <el-button
      type="default"
      size="mini"
      icon="mdi mdi-help-circle"
      class="action"
      @click="showGuideFilezilla = true"
    >
      How-to use with FileZilla
    </el-button>

    <el-divider content-position="left">
      <h3>Access files by SFTP</h3>
    </el-divider>

    <el-alert
      v-if="!user.ssh && !application.ssh"
      type="error"
      effect="dark"
      title="To access all servers files you must upload or create a ssh key pair"
      :closable="false"
    >
      <el-button
        type="danger"
        icon="mdi mdi-key-variant"
        size="mini"
        plain
        @click="showGenerate = true"
      >
        Create a personal key
      </el-button>

      <router-link size="mini" to="/account">Upload a personal key</router-link>
    </el-alert>

    <div v-else class="quickconnect">
      <el-input :value="instance.publicIp" class="host" readonly>
        <template slot="prepend">Host</template>
      </el-input>

      <el-input :value="application.name" class="username" readonly>
        <template slot="prepend">User</template>
      </el-input>

      <el-input :value="port" class="port" readonly>
        <template slot="prepend">Port</template>
      </el-input>
    </div>

    <el-card class="application-key" shadow="never">
      <div slot="header">
        <el-button
          type="info"
          icon="mdi mdi-key-variant"
          size="mini"
          plain
          @click="showApplicationGenerate = true"
        >
          Generate
        </el-button>

        <i class="mdi mdi-key" />
        Application Key
      </div>

      <div v-if="application.ssh" class="the-key">
        A key has been activated since <strong>{{ fromNow(application.ssh.created) }}</strong>,
        generated by <strong>{{ application.ssh.owner }}</strong> &ndash;
        <el-button type="text" size="small" @click="revoke">revoke this key</el-button>
      </div>

      <small v-else><em>No key created for this application.</em></small>
    </el-card>

    <el-card shadow="never">
      <div slot="header">
        <i class="el-icon-unlock" />
        SSH connection history
      </div>

      <Actions
        name="ssh.connect"
        :instance-id="instance.id"
        :application-name="application.name"
      />
    </el-card>

    <AccountGenerateKey :visible.sync="showGenerate" />
    <ApplicationGenerateKey
      :application-id="application.id"
      :application-name="application.alias"
      :visible.sync="showApplicationGenerate"
    />

    <GuideFilezilla
      :visible.sync="showGuideFilezilla"
      :host="instance.publicIp"
      :username="application.name"
      :port="port"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Actions from '../Account/Actions'
import GuideFilezilla from '../Guides/Filezilla'
import AccountGenerateKey from '../Account/GenerateKey'
import ApplicationGenerateKey from './GenerateKey'

export default {
  props: {
    instance: Object,
    application: Object,
    port: {
      type: Number,
      default: 22
    }
  },
  components: {
    Actions,
    AccountGenerateKey,
    ApplicationGenerateKey,
    GuideFilezilla
  },
  data () {
    return {
      showGenerate: false,
      showApplicationGenerate: false,
      showGuideFilezilla: false
    }
  },
  computed: mapState(['user']),
  methods: {
    revoke () {
      this.$confirm('The access with this key will no longer be accessible. Continue?', 'Revoke', {
        confirmButtonText: 'Revoke',
        cancelButtonText: 'Cancel',
        confirmButtonClass: 'el-button--danger',
        type: 'warning'
      }).then(() => {
        return this.$store.dispatch('revokeApplicationKey', this.application.id)
          .then(() => this.$store.dispatch('getApplications'))
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../theme";

  .quickconnect {
    .el-input {
      margin-right: 10px;

      &.host {
        max-width: 210px;
      }
      &.username {
        max-width: 230px;
      }
      &.port {
        max-width: 130px;
      }
    }
  }
  .application-key {
    .el-button--info {
      float: right;
    }
    .the-key {
      .el-button {
        color: $--color-danger;
      }
    }
  }
  .el-card {
    margin-top: 35px;
  }
  .el-alert {
    a {
      color: #ffffff;
      text-decoration: none;
      margin-left: 10px;
    }
    .el-button--danger:hover {
      background: #ffffff;
      color: #F56C6C;
    }
  }
</style>
